module.exports = __webpack_public_path__ + "static/map-zoom-b1fe071773fd210b6610a56594f85503.jpg";